import script from "./BookingStatusDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingStatusDisplay.vue?vue&type=script&setup=true&lang=js"

import "./BookingStatusDisplay.vue?vue&type=style&index=0&id=e10d90b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e10d90b4"]])

export default __exports__